/**
* @Author: zachalam
* @Date:   2017-01-26T14:15:34-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-26T14:15:34-08:00
*/

import * as sdk from '../sdk';
import { browserHistory } from 'react-router';
import {
  storeErrors,
  storeSpecificErrors,
  clearErrors,
  setLoading,
} from './commonActions';
import { storeMeta } from './metaActions';
import { toast } from 'react-toastify';
import MASTER from '../config/Master';
import isArray from 'lodash/isArray';

export const getProfile = (payload) => {
  return {
    type: 'STORE_PROFILE',
    payload
  }
}

export const getExternalProfile = (payload) => {
  return {
    type: 'STORE_PROFILE_EXTERNAL',
    payload
  }
}

export const remExternalProfile = () => {
  return {
    type: 'REMOVE_PROFILE_EXTERNAL'
  }
}

export const storeSettings = (payload) => {
  return {
    type: 'STORE_SETTINGS',
    payload
  }
}

export const requestBlocked = payload => {
  return {
    type: 'REQUEST_BLOCKED'
  }
}

export const storeBlocked = (payload) => {
  return {
    type: 'STORE_BLOCKED',
    payload
  }
}

export const clearBlocked = () => {
  return {
    type: 'CLEAR_BLOCKED'
  }
}

export const invertSetting = (payload) => {
  return {
    type: 'INVERT_SETTING',
    payload
  }
}

export const storeSinglePhoto = (payload) => {
  return {
    type: 'STORE_SINGLE_PHOTO',
    payload
  }
}

export const removePhoto = (photoKey) => {
  return {
    type: 'DELETE_SINGLE_PHOTO',
    payload: photoKey
  }
}

export const storeDefaultPhoto = (photoKey) => {
  return {
    type: 'STORE_DEFAULT_PHOTO',
    payload: photoKey
  }
}

export const storeNewPrivacy = (photoKey) => {
  return {
    type: 'STORE_NEW_PRIVACY',
    payload: photoKey
  }
}


export const makePremium = () => {
  return {
    type: 'MAKE_PREMIUM'
  }
}

export const showTOS = () => {
  return {
    type: 'SHOW_TOS'
  }
}

export const hideTOS = () => {
  return {
    type: 'HIDE_TOS'
  };

}

// block a specific user (when viewing their extprofile)
export const toggleBlockInStore = (username) => {
  return {
    type: 'TOGGLE_BLOCK_USER_PROFILE',
    payload: username
  }
}
//---------

export const createProfile = (formData) => {
  return (dispatch, getState) => {
    return sdk.createUserProfile(getState().auth.jwToken,formData)
              .then((response) => {
                // refresh profile now
                dispatch(refreshProfile());
              })
  }
}

export const refreshProfile = () => {
  // get the logged in users profile
  return (dispatch, getState) => {
    return sdk.getLoggedProfile(getState().auth.jwToken)
              .then((response) => {
                let accountData = response.data.data;
                dispatch(getProfile(accountData));

                return accountData;

              })
              .catch((error) => {
              });
  }
}

export const refreshAccount = () => {
  return (dispatch, getState) => {
    return sdk.getLoggedAccount(getState().auth.jwToken)
              .then((response) => {
                let accountData = response.data.data;
                dispatch(getProfile(accountData));
              })
              .catch((error) => {
              });
  }
}

export const updateProfile = (formData, username) => {
  return (dispatch, getState) => {
    return sdk.updateLoggedProfile(getState().auth.jwToken, formData)
              .then((response) => {
                // clear errors
                dispatch(clearErrors());
                // save new profile
                dispatch(getProfile(response.data.data));
                // redirect to dashboard
                browserHistory.push(`/~${username}`);
                // notify by toast
                toast('Profile Successfully Updated', {type: toast.TYPE.INFO});
              })
              .catch((error) => {
                dispatch(storeErrors(error.response.data));
              })
  }
}

export const refreshExternalProfile = (username) => {
  return (dispatch, getState) => {
    dispatch(remExternalProfile());

    return sdk.getExternalProfile(getState().auth.jwToken,username)
              .then((response) => {
                dispatch(getExternalProfile(response.data.data));
              })
              .catch((error) => {
                // could not find this profile.
                browserHistory.push("/404");
              });
  }
}


export const getProfileSettings = () => {
  return (dispatch, getState) => {
    return sdk.getAccountSettings(getState().auth.jwToken)
              .then((response) => {
                dispatch(storeSettings(response.data.data));
              });
  }
}

export const refreshBlockedList = (firstCall=true, per_page=MASTER.per_page) => {
  return (dispatch, getState) => {
    let pageToGet = 0;

    if(firstCall) {
      dispatch(clearBlocked());
    } else {
      pageToGet = getState().meta.blocked_current_page+1;
    }

    dispatch(requestBlocked());

    return sdk.getBlockedList(getState().auth.jwToken, pageToGet, per_page)
      .then((response) => {
        dispatch(storeBlocked(response.data.data));

        const PAGE = response.data.meta.pagination;
        dispatch(storeMeta({
          blocked_current_page: PAGE.current_page,
          blocked_total_pages: PAGE.total_pages
        }));
      });
  }

}

export const updateProfileSetting = () => {
  return (dispatch, getState) => {
    return sdk.updateAccountSettings(getState().auth.jwToken, getState().settings);
  }
}

export const updatePassword = (formData) => {
  return (dispatch, getState) => {
    return sdk.updateAccountPassword(getState().auth.jwToken,formData)
              .then((response) => {
                // password successfully updated. clear form and toast
                dispatch(clearErrors());
                toast('Password Successfully Updated', {type: toast.TYPE.INFO});
              })
              .catch((error) => {
                // display password errors to users
                dispatch(storeSpecificErrors("error_password",error.response.data));
              });
  }
}

export const updateEmail = (formData) => {
  return (dispatch, getState) => {
    return sdk.updateAccountEmail(getState().auth.jwToken,formData)
              .then((response) => {
                // email updated, clear form and toast..
                dispatch(clearErrors());
                toast('Email Successfully Updated', {type: toast.TYPE.INFO});
                // reload settings - email was updated.
                dispatch(getProfileSettings());
              })
              .catch((error) => {
                // couldnt update email, display error.
                dispatch(storeSpecificErrors("error_email",error.response.data));
              });
  }
}


export const addNewPhoto = (formData) => {
  return (dispatch, getState) => {
    dispatch(setLoading());
    return sdk.postNewPhoto(getState().auth.jwToken,formData)
              .then((response) => {
                // new photo accepted.
                dispatch(storeSinglePhoto(response.data.data));
                // update main profile photo.
                dispatch(refreshProfile());
                dispatch(setLoading());

              })
              .catch(error => {
                dispatch(setLoading());
                // toast error
                if(error && error.response && error.response.data && error.response.data.photo) {
                  if(isArray(error.response.data.photo)) {
                    error.response.data.photo.forEach(err => {
                      console.error(err);
                      toast.warn(err);
                    });
                  } else {
                    toast.warn(error.response.data.photo);
                  }
                } else {
                  toast.warn("Could not upload photo");
                }
              });
  }
}

export const deletePhoto = (photoId) => {
  return (dispatch, getState) => {
    return sdk.deletePhoto(getState().auth.jwToken,photoId)
              .then((resp) => { dispatch(refreshProfile()); /* refresh main photo */ });
  }
}

export const makePhotoDefault = (photoId,photoKey) => {
  // set default photo.
  return (dispatch, getState) => {
    // notify store
    dispatch(storeDefaultPhoto(photoKey));
    // notify api
    return sdk.putPhotoAvatar(getState().auth.jwToken,photoId)
              .then((resp) => { dispatch(refreshProfile()); /* refresh main photo */ });
  }
}

export const setNewPrivacy = (photoId,photoKey) => {
  // set new photo privacy.
  return (dispatch, getState) => {
    // notify store
    dispatch(storeNewPrivacy(photoKey));
    // notify api
    return sdk.putPhotoPrivacy(getState().auth.jwToken,photoId);
  }
}


export const reportUser = (formData) => {
  return (dispatch, getState) => {
    return sdk.reportUser(getState().auth.jwToken, formData)
              .then((response) => {
                // clear errors
                dispatch(clearErrors());
                // redirect user to dashboard
                browserHistory.push("/search");
                // notify by toast
                toast('Profile Reported', {type: toast.TYPE.INFO});

              })
              .catch((error) => {
                dispatch(storeErrors(error.response.data));
              })
  }
}

export const toggleBlockProfile = (username) => {
  return (dispatch, getState) => {
    return sdk.blockUser(getState().auth.jwToken,username);
  }
}



// WEBPACK FOOTER //
// ./src/actions/profileActions.js